import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Activities from './view/activities';
import ActivitiesCheckIn from './view/activities-checkIn';

const ActivitiesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Activities />} />
    <Route path='/check-in' element={<ActivitiesCheckIn />} />
  </ErrorBoundaryRoutes>
);

export default ActivitiesRoutes;
